import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DeleteVisitorModalComponent } from 'src/app/admin/components/modals/delete-visitor-modal/delete-visitor-modal.component';
import { EditVisitorModalComponent } from '../../components/modals/edit-visitor-modal/edit-visitor-modal.component';
import { Visitor } from 'src/app/admin/models/visitor';
import { VisitorService } from 'src/app/admin/services/visitor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { Playroom } from 'src/app/admin/models/playroom.model';

@Component({
  selector: 'app-manage-visitors-page',
  templateUrl: './manage-visitors.page.html',
  styleUrls: ['./manage-visitors.page.scss'],
})

export class ManageVisitorsPage implements OnInit {
  visitors$ = this.visitorService.visitors$;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  fullNameQuery: string = '';
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  roomNameQuery: string = '';

  dateBirthFromQuery: string = ''
  dateBirthToQuery: string = ''
  registrationDateQuery: string = '';

  registrationDateFromQuery: string = ""
  registrationDateToQuery: string = ""
  visitorBirthMonthFromQuery: string = ""
  visitorBirthMonthToQuery: string = ""
  visitorBirthYearFromQuery: string = ""
  visitorBirthYearToQuery: string = ""

  paginationSettings = { totalItems: 0 };
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  currentPage: number = 1;
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  itemsPerPage: number = 20;
  visitor: Visitor = new Visitor();
  pageSize: number = 2147483647;
  onlyChildren: boolean = false;
  onlyParents: boolean = false;
  visitorTypeQuery: string = '';
  marketingMessageQuery: string = '';
  visitorsArray: any
  playrooms: Playroom[] = [];
  ChildrenNames: string
  FullName: string

  constructor(private visitorService: VisitorService, private modalController: ModalController, private router: Router,  private route: ActivatedRoute, private playroomService: PlayroomService       ) { }

  ngOnInit(): void {

    this.applyVisitorTypeFilter();

    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, onlyParents: this.onlyParents,
      marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
      registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
      visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
      visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery,
      roomNameQuery: this.roomNameQuery


    });
    console.log('VISITORSS', this.visitors$)
    this.visitorService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });

     this.route.queryParamMap.subscribe(q => {
    const qpPhone = q.get('phone');
    if (qpPhone) {
      this.phoneQuery = qpPhone;
      console.log('[CALL] prefill phone from query:', this.phoneQuery);
      this.loadSearchResult();
    }
  });

  this.visitorService.paginationSettings$.subscribe(pag => this.paginationSettings = pag);

  this.playroomService.getAllPlayroomsSub().subscribe((rooms) => {
    this.playrooms = rooms || [];
  });

    this.getArrayChildrenNames()

  }

  downloadSignature(visitor) {
    const guid = visitor.signatureUrl.split('Signature/')[1];
    this.visitorService.getSignature(guid).subscribe(res => {
      const source = URL.createObjectURL(res);
      const el = document.createElement("a");
      el.setAttribute("href", source);
      el.setAttribute("download", `${visitor.fullName.replace(/\s/g, '_')}${visitor.phone}`);
      document.body.appendChild(el);
      el.click();
      el.remove();
    })

    console.log('GUID', guid)
    console.log('GUID', this.visitor)

  }

  async openDeleteVisitorModal(visitor) {
    const modal = await this.modalController.create({
      component: DeleteVisitorModalComponent,
      componentProps: { visitor: { ...visitor, children: this.visitor.children } },
      cssClass: 'small-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

  async openEditVisitorModal(visitor) {
    const modal = await this.modalController.create({
      component: EditVisitorModalComponent,
      componentProps: { visitor: { ...visitor, children: this.visitor.children } },
      cssClass: 'medium-modal-css',
      backdropDismiss: true,
      swipeToClose: false,
    });
    await modal.present();
  }

openKarticaVisitora(visitor) {
    if (visitor.birhdayId != null ) {
    this.router.navigate(
      ['/admin/birthday-edit-from-form-calendar'],
      {
        queryParams: {
          savedTimeSlotId: visitor.timwSlotConfigurationId,
          birthdayId: visitor.birhdayId
        }
      }
    );
  } 
    else{
    this.router.navigate(['admin/kartica-visitora', visitor.id]);
    }
  }



openKarticaVisitoraAdd(visitor){
 this.router.navigate(['admin/kartica-visitora', visitor.id]);

}


  async loadSearchResult() {
    this.applyVisitorTypeFilter();
    this.currentPage = 1
    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, onlyParents: this.onlyParents,
      marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
      registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
      visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
      visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery,
      roomNameQuery: this.roomNameQuery
    });
  }

  resetFilters() {
    this.fullNameQuery = '';
    this.emailQuery = '';
    this.phoneQuery = '';
    this.visitorStatusQuery = '';
    this.visitorTypeQuery = '';
    this.onlyChildren = false;
    this.onlyParents = false;
    this.roomNameQuery = '';
    this.marketingMessageQuery = '';
    this.dateBirthFromQuery = '';
    this.dateBirthToQuery = '';
    this.registrationDateFromQuery = ''
    this.registrationDateToQuery = ''
    this.visitorBirthMonthFromQuery = ''
    this.visitorBirthMonthToQuery = ''
    this.visitorBirthYearFromQuery = ''
    this.visitorBirthYearToQuery = ''

    this.currentPage = 1;
    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery,
      emailQuery: this.emailQuery,
      phoneQuery: this.phoneQuery,
      visitorStatusQuery: this.visitorStatusQuery,
      onlyChildren: this.onlyChildren,
      onlyParents: this.onlyParents,
      marketingMessageQuery: this.marketingMessageQuery,
      dateBirthFromQuery: this.dateBirthFromQuery,
      dateBirthToQuery: this.dateBirthToQuery,
      registrationDateFromQuery: this.registrationDateFromQuery,
      registrationDateToQuery: this.registrationDateToQuery,
      visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery,
      visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
      visitorBirthYearFromQuery: this.visitorBirthYearFromQuery,
      visitorBirthYearToQuery: this.visitorBirthYearToQuery,
      roomNameQuery: this.roomNameQuery
    });

  }

  changePage(pageNumber) {
    this.applyVisitorTypeFilter();
    this.currentPage = pageNumber;
    this.visitorService.getAllVisitorsSearch({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameQuery: this.fullNameQuery, emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, onlyParents: this.onlyParents,
      marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
      registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
      visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
      visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery,
      roomNameQuery: this.roomNameQuery

    });
  }

  blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }

  CSV() {

    this.applyVisitorTypeFilter();

    this.visitorService.exportCSV({
      currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, pageSize: this.pageSize,
      fullNameQuery: this.fullNameQuery, emailQuery: this.emailQuery, phoneQuery: this.phoneQuery,
      visitorStatusQuery: this.visitorStatusQuery, onlyChildren: this.onlyChildren, onlyParents: this.onlyParents,
      marketingMessageQuery: this.marketingMessageQuery, dateBirthFromQuery: this.dateBirthFromQuery, dateBirthToQuery: this.dateBirthToQuery,
      registrationDateFromQuery: this.registrationDateFromQuery, registrationDateToQuery: this.registrationDateToQuery,
      visitorBirthMonthFromQuery: this.visitorBirthMonthFromQuery, visitorBirthMonthToQuery: this.visitorBirthMonthToQuery,
      visitorBirthYearFromQuery: this.visitorBirthYearFromQuery, visitorBirthYearToQuery: this.visitorBirthYearToQuery,
      roomNameQuery: this.roomNameQuery
    }).subscribe
      (
        response => {
          this.blobToFile(response, "text/csv", "Export.csv");
        }
      )

  }

  applyVisitorTypeFilter() {
    if (this.visitorTypeQuery === 'child') {
      this.onlyChildren = true;
      this.onlyParents = false;
      return;
    }

    if (this.visitorTypeQuery === 'parent') {
      this.onlyChildren = false;
      this.onlyParents = true;
      return;
    }

    this.onlyChildren = false;
    this.onlyParents = false;
  }

  getVisitorStatus(value: number) {
    if (value === 0) {
      return 'Registrovan';
    }
    else if (value === 1) {
      return 'Nepouzdan';
    }
    else if (value === 2) {
      return 'Odjavljen';
    }
    else if (value === 3) {
      return 'Blokiran';
    }
    return 'Neregistrovan';
  }
  getArrayChildrenNames() {

    this.visitors$.subscribe({
      next: (arr) => {
        var i: number;
        var j: number;
        this.visitorsArray = arr
        var len = this.visitorsArray.length;

        for (i = 0; i < len; i++) {

          this.visitorsArray[i].children
          if (this.visitorsArray[i].children.length == 0) {

            let ChildrenNamesArray = new Array<string>()
            this.FullName = "-";
            ChildrenNamesArray.push(this.FullName)
            this.ChildrenNames = ChildrenNamesArray.join(' ');

          }
          else {
            let ChildrenNamesArray = new Array<string>()
            for (j = 0; j < this.visitorsArray[i].children.length; j++) {

              this.FullName = this.visitorsArray[i].children[j].fullName;

              ChildrenNamesArray.push(this.FullName)

            }
            this.ChildrenNames = ChildrenNamesArray.join(', ');

          }
          this.visitorsArray[i].children.push(this.ChildrenNames)

        }
      },

    });
  }

  presentProprtDate(value) {
    if (value === "1.1.0001.") {
      return "-"
    }
    else {
      return value
    }

  }

yearHelper(value: number) {
  if (value !== 1 && value !== 1800 && value !== 1970) {
    return value;
  } else {
    return '-';
  }
}

munthHelper(value: number, value1: number) {

  if (value === 1 && (value1 === 1800 || value1 === 1970)) {
    return '-';
  }

  if (value === 1 && value1 !== 1) {
    return 'Januar';
  }
  else if (value === 2 && value1 !== 1) {
    return 'Februar';
  }
  else if (value === 3 && value1 !== 1) {
    return 'Mart';
  }
  else if (value === 4 && value1 !== 1) {
    return 'April';
  }
  else if (value === 5 && value1 !== 1) {
    return 'Maj';
  }
  else if (value === 6 && value1 !== 1) {
    return 'Juni';
  }
  else if (value === 7 && value1 !== 1) {
    return 'Juli';
  }
  else if (value === 8 && value1 !== 1) {
    return 'Avgust';
  }
  else if (value === 9 && value1 !== 1) {
    return 'Septembar';
  }
  else if (value === 10 && value1 !== 1) {
    return 'Oktobar';
  }
  else if (value === 11 && value1 !== 1) {
    return 'Novembar';
  }
  else if (value === 12 && value1 !== 1) {
    return 'Decembar';
  }
  else {
    return '-';
  }
}

}